var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-main common" }, [
    _c(
      "div",
      { staticClass: "spaceCenter", staticStyle: { "max-width": "80%" } },
      [
        _c(
          "a-form-model",
          {
            ref: "bindingAddForm",
            staticClass: "common-form-inline",
            staticStyle: { width: "330px", "margin-top": "30px" },
            attrs: {
              model: _vm.pageData,
              rules: _vm.rules,
              "label-col": _vm.labelCol,
              "wrapper-col": _vm.wrapperCol
            }
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "账户户名", prop: "accNm" } },
              [_c("span", [_vm._v(_vm._s(_vm.pageData.accNm))])]
            ),
            _vm._v(" "),
            _c(
              "a-form-model-item",
              { attrs: { label: "账户账号", prop: "accNo" } },
              [
                _c("a-input", {
                  attrs: { disabled: _vm.pageType == "detail" },
                  model: {
                    value: _vm.pageData.accNo,
                    callback: function($$v) {
                      _vm.$set(_vm.pageData, "accNo", $$v)
                    },
                    expression: "pageData.accNo"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-model-item",
              { attrs: { label: "开户银行", prop: "accBlngBnk" } },
              [
                _c("a-input", {
                  attrs: { disabled: _vm.pageType == "detail" },
                  model: {
                    value: _vm.pageData.accBlngBnk,
                    callback: function($$v) {
                      _vm.$set(_vm.pageData, "accBlngBnk", $$v)
                    },
                    expression: "pageData.accBlngBnk"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-model-item",
              { attrs: { label: "大额行号", prop: "largeBankNo" } },
              [
                _c("a-input", {
                  attrs: { disabled: _vm.pageType == "detail" },
                  model: {
                    value: _vm.pageData.largeBankNo,
                    callback: function($$v) {
                      _vm.$set(_vm.pageData, "largeBankNo", $$v)
                    },
                    expression: "pageData.largeBankNo"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-form-model-item",
              { attrs: { label: "开户证明", prop: "accountOpenCertify" } },
              [
                _c("a-input", {
                  attrs: { disabled: true, placeholder: "请选择附件" },
                  model: {
                    value: _vm.pageData.accountOpenCertify,
                    callback: function($$v) {
                      _vm.$set(_vm.pageData, "accountOpenCertify", $$v)
                    },
                    expression: "pageData.accountOpenCertify"
                  }
                }),
                _vm._v(" "),
                _vm.pageType != "detail"
                  ? _c(
                      "a-upload",
                      {
                        staticClass: "upload-btn",
                        attrs: {
                          "file-list": _vm.fileList,
                          "before-upload": _vm.beforeFileUpload,
                          showUploadList: false,
                          customRequest: _vm.handleFileUpload
                        }
                      },
                      [
                        _c(
                          "a-button",
                          {
                            staticClass: "btn-blue-line",
                            staticStyle: { "margin-left": "20px" },
                            attrs: { loading: _vm.uploading }
                          },
                          [_vm._v("选择文件 ")]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pageType == "detail"
                  ? _c(
                      "a-button",
                      {
                        staticClass: "btn-blue-line upload-btn",
                        staticStyle: { "margin-left": "20px" },
                        on: { click: _vm.download }
                      },
                      [_vm._v("附件下载 ")]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "model-footer-btns spaceCenter",
        staticStyle: { "max-width": "80%" }
      },
      [
        _c(
          "a-button",
          { staticClass: "btn-blue-line btn-big", on: { click: _vm.goback } },
          [_vm._v("取消")]
        ),
        _vm._v(" "),
        _vm.pageType != "detail"
          ? _c(
              "a-button",
              {
                staticClass: "btn-big",
                attrs: { type: "primary" },
                on: { click: _vm.submit }
              },
              [_vm._v("确认")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e18ac99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e18ac99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/binding/binding-add.vue
// module id = obz7
// module chunks = 1